class CollageMediaComponent extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('.collage-media-modal');

    this.addEventListener('click', (e) => {
      const playBtn = e.target.closest('button.collage-media__play');
      if (playBtn) {
        const parent = playBtn.closest('.collage-media__card, .collage-media__hero');
        if (!parent) return;
        const video = parent.querySelector('video.collage-media__card-image, video.collage-media__hero-image');
        if (!video) return;
        this._openModal(video);
        return;
      }

      if (e.target.closest('.collage-media-modal__close')) {
        this._closeModal();
        return;
      }

      if (e.target.classList.contains('collage-media-modal__backdrop')) {
        this._closeModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal && !this.modal.hidden) {
        this._closeModal();
      }
    });
  }

  _openModal(srcVideo) {
    const wrap = this.modal.querySelector('.collage-media-modal__media-wrap');
    wrap.innerHTML = '';

    const video = srcVideo.cloneNode(true);
    video.removeAttribute('class');
    video.removeAttribute('preload');
    video.controls = true;
    video.autoplay = true;
    video.muted = false;
    wrap.appendChild(video);
    video.load();
    video.play().catch(() => {});

    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.modal.querySelector('.collage-media-modal__close').focus();
  }

  _closeModal() {
    const video = this.modal.querySelector('video');
    if (video) video.pause();
    this.modal.querySelector('.collage-media-modal__media-wrap').innerHTML = '';
    this.modal.hidden = true;
    document.body.style.overflow = '';
  }
}

customElements.define('collage-media-component', CollageMediaComponent);
